<div class="dialog">

    <div class="dialog-header">
        <h3>{{ 'SALES_DOCUMENT|Utwórz zamówienie klienta' | translate }}</h3>
        <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
            <icc-icon name="close"></icc-icon>
        </button>
    </div>
    <div class="dialog-body">
        <p class="quotation-code"><ng-container *ngIf="data.document.salesDocumentTypeId !== 3 && data.document.salesDocumentTypeId !== 5">{{'SALES_DOCUMENT|Nr oferty:' | translate}}</ng-container><ng-container *ngIf="data.document.salesDocumentTypeId === 3">{{'SALES_DOCUMENT|Nr zamówienia:' | translate}}</ng-container><ng-container *ngIf="data.document.salesDocumentTypeId === 5">{{'SALES_DOCUMENT|Nr zamówienia serwisowego:' | translate}}</ng-container> <b>{{data.document.documentNumber.join('')}}</b></p>
        <div class="flex-horizontal">
            <div *ngIf="data.document?.client && (data.document?.client.delivery || data.document?.client.invoice)" class="addresses">
                <div class="address-box" *ngIf="data.document?.client.delivery as address">
                    <header>{{'CONTACT|Adres dostawy' | translate}}:</header>
                    <b>
                        <span *ngIf="data.document?.client?.companyName">{{ data.document?.client?.companyName }}<br></span>
                        <span *ngIf="!data.document?.client?.isCompany">{{ data.document?.client?.firstName }} {{ data.document?.client?.lastName }}<br></span>
                        <span *ngIf="address.addressLine1">{{ address.addressLine1 }}<br></span>
                        <span *ngIf="address.addressLine2">{{ address.addressLine2 }}<br></span>
                        <span *ngIf="address.postalCode">{{ address.postalCode }}</span>&nbsp;<span *ngIf="address.city">{{ address.city }}<br></span>
                    </b>
                    <span>
                        <span *ngIf="data.document?.client?.phoneNumber">{{ 'CONTACT|tel.' | translate }} {{ data.document?.client?.phoneNumber }}<br></span>
                        {{ 'CONTACT|email:' | translate }} {{ data.document?.client?.email }}
                    </span>
                </div>
                <div class="address-box" *ngIf="data.document?.client.invoice as address">
                    <header>{{'CONTACT|Dane do faktury' | translate}}:</header>
                    <b>
                        <span *ngIf="data.document?.client?.companyName">{{ data.document?.client?.companyName }}<br></span>
                        <span *ngIf="!data.document?.client?.isCompany">{{ data.document?.client?.firstName }} {{ data.document?.client?.lastName }}<br></span>
                        <span *ngIf="address.addressLine1">{{ address.addressLine1 }}<br></span>
                        <span *ngIf="address.addressLine2">{{ address.addressLine2 }}<br></span>
                        <span *ngIf="address.postalCode">{{ address.postalCode }}</span>&nbsp;<span *ngIf="address.city">{{ address.city }}<br></span>
                        <span *ngIf="data.document?.client?.companyVatNr">{{ 'SALES_DOCUMENT|NIP:' | translate }} {{ data.document?.client?.companyVatNr }}<br></span>
                    </b>
                    <span>
                        {{ 'CONTACT|email:' | translate }} {{ data.document?.client?.email }}
                    </span>
                </div>
            </div>
            <div class="delivery-dates" *ngIf="!orderLater">
                <header *ngIf="!deliveryDates?.length">{{'SALES_DOCUMENT|Szacowany termin realizacji' | translate}}:</header>
                <header *ngIf="deliveryDates?.length">{{'SALES_DOCUMENT|Termin realizacji' | translate}}:</header>

                <select *ngIf="deliveryDates.length && !updatingDeliveryDates" iccSelect [(ngModel)]="deliveryDate" required>
                    <option *ngFor="let date of deliveryDates" [value]="date" >
                        {{ date }}
                    </option>
                </select>

                <ng-container *ngIf="updatingDeliveryDates">
                    <p translate class="info">{{ 'SALES_DOCUMENT|Pobieranie terminów realizacji...' }}</p>
                </ng-container>

                <ng-container *ngIf="!deliveryDates.length && !updatingDeliveryDates">
                    <p *ngFor="let doc of data.buyDocuments; index as i">
                        <ng-container *ngIf="data.buyDocuments.length > 1"><b>
                            <ng-container *ngIf="data.buyDocuments.length > 1">#{{i + 1}}. </ng-container>
                            <ng-container *ngIf="departments[doc.sellerProductDepartmentId]">{{departments[doc.sellerProductDepartmentId]}}</ng-container>
                        </b> - </ng-container>{{ estimatedDeadlineText || '' }}
                    </p>
                    <p translate class="info" *ngIf="!estimatedDeadlineInfo">SALES_DOCUMENT|(Potwierdzenie terminu i uzgodnienie dostaw po zamówieniu)</p>
                    <p translate class="info" *ngIf="estimatedDeadlineInfo" [innerHTML]="estimatedDeadlineInfo"></p>
                </ng-container>
            </div>
        </div>
        <div class="flex-horizontal" *ngIf="placedUnexpectedError">
            <div class="document-card_status">
                <span class="document-card_status__label">
                    {{ 'SALES_DOCUMENT|Status dokumentu sprzedażowego:' | translate }}
                </span>
                <span class="document-card_status__detail">
                    <icc-document-status [status]="getStatus(salesOrder)"></icc-document-status>
                </span>
            </div>
            <div class="document-card_status">
                <span class="document-card_status__label">
                    {{ 'SALES_DOCUMENT|Status dokumentu zakupowego:' | translate }}
                </span>
                <span class="document-card_status__detail">
                    <icc-document-status [status]="getStatus(buyOrder)"></icc-document-status>
                </span>
            </div>
        </div>
        <div class="order-options" *ngIf="data.buyDocuments?.length > 0 && !data.onlyPlace">
            <ng-container *ngIf="canOrderLater">
                <div class="icc-radio-buttons" *ngxPermissionsOnly="'purchase-make-order'">
                    <span>
                        <icc-radio id="order-now" name="mode" [value]="false" [(ngModel)]="orderLater">
                            {{ 'SALES_DOCUMENT|Zamów od razu' | translate }}
                        </icc-radio>
                    </span>
                    <span>
                        <icc-radio id="order-later" name="mode" [value]="true" [(ngModel)]="orderLater" >
                            {{ 'SALES_DOCUMENT|Zamów później' | translate }}
                        <icc-icon name="info-circle" class="info-circle" [title]="'SALES_DOCUMENT|Zamówienie zakupowe nie zostanie od razu złożone. Zostanie dodane do listy dokumentów oczekujących na zamówienie.' | translate"></icc-icon>
                        </icc-radio>
                    </span>
                </div>
            </ng-container>
            <p *ngxPermissionsExcept="'purchase-make-order'">{{ 'SALES_DOCUMENT|Zamówienie zakupowe nie zostanie od razu złożone. Zostanie dodane do listy dokumentów oczekujących na zamówienie.' | translate }}</p>
        </div>
    </div>
    <div class="dialog-footer flex-vertical">

        <div class="flex-horizontal w-100">

            <button
                iccButton
                (click)="close()"
                appearance="secondary"
                [disabled]="orderInProgress"
            >
                {{ 'INTERFACE|Anuluj' | translate}}
            </button>

            <div class="right">
                <span class="space"></span>
                <button iccButton (click)="createOrder()" [disabled]="!canBeOrdered" *ngIf="!placedUnexpectedError">{{ 'SALES_DOCUMENT|Utwórz zamówienie' | translate}}</button>
                <button iccButton (click)="createOrder()" [disabled]="!canBeOrdered" *ngIf="placedUnexpectedError">{{ 'SALES_DOCUMENT|Ponów zamówienie' | translate}}</button>
                <button iccButton (click)="resignOrder()" [disabled]="!canBeOrdered" *ngIf="placedUnexpectedError">{{ 'SALES_DOCUMENT|Zrezygnuj' | translate}}</button>
            </div>

        </div>
        <div class="w-100" *ngIf="!messages.length && message">
            <p [class.error]="messageState === 'error'" class="dialog-message">{{ message }}</p>
        </div>
        <div class="w-100" *ngIf="messages.length">
            <p [class.error]="messageState === 'error'" class="dialog-message" *ngFor="let msg of messages">{{ msg }}</p>
        </div>
    </div>
</div>
<div
    class="curtain"
    (click)="close()"
></div>
